import { useSelectContext } from './context'
import { type OptionData, type OptionApi } from './types'

export function useOption(option: OptionData): OptionApi {
  const register = useSelectContext()
  return register(option)
}
